import styled from 'styled-components';

interface Props {
  expand?: boolean;
}

export const StyledReorderViewAllContainer = styled.div<Props>`
  ${({ expand }) => `
    --reorder-view-all-container__flex-grow: ${expand ? '1' : 'auto'};
  `}

  flex-grow: var(--reorder-view-all-container__flex-grow);
  margin: 0 0 0 auto;
  text-align: right;
`;

export const StyledReorderViewAll = styled.a(({ theme }) => ({
  textDecoration: 'underline',
  fontSize: '14px',
  lineHeight: '24px',
  color: theme.buttons.primary_button_background_color,
}));
